function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import { TextInput as RaTextInput, BooleanInput as RaBooleanInput, NullableBooleanInput as RaNullableBooleanInput, DateInput as RaDateInput, DateTimeInput as RaDateTimeInput, ImageInput as RaImageInput, FileInput as RaFileInput, NumberInput as RaNumberInput, PasswordInput as RaPasswordInput, AutocompleteInput as RaAutocompleteInput, RadioButtonGroupInput as RaRadioButtonGroupInput, SelectInput as RaSelectInput, ArrayInput as RaArrayInput, AutocompleteArrayInput as RaAutocompleteArrayInput, CheckboxGroupInput as RaCheckboxGroupInput, SelectArrayInput as RaSelectArrayInput, ReferenceArrayInput as RaReferenceArrayInput, ReferenceInput as RaReferenceInput } from "react-admin";
import { RbacInput } from "./rbac-input.js";
export const TextInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaTextInput
}));
export const BooleanInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaBooleanInput
}));
export const NullableBooleanInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaNullableBooleanInput
}));
export const DateInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaDateInput
}));
export const DateTimeInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaDateTimeInput
}));
export const ImageInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaImageInput
}));
export const FileInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaFileInput
}));
export const NumberInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaNumberInput
}));
export const PasswordInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaPasswordInput
}));
export const AutocompleteInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaAutocompleteInput
}));
export const RadioButtonGroupInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaRadioButtonGroupInput
}));
export const SelectInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaSelectInput
}));
export const ArrayInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaArrayInput
}));
export const AutocompleteArrayInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaAutocompleteArrayInput
}));
export const CheckboxGroupInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaCheckboxGroupInput
}));
export const SelectArrayInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaSelectArrayInput
}));
export const ReferenceArrayInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaReferenceArrayInput
}));
export const ReferenceInput = props => /*#__PURE__*/React.createElement(RbacInput, _extends({}, props, {
  component: RaReferenceInput
}));